exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-alert-container{background-color:#2d74da;flex-grow:1}", ""]);

// exports
exports.locals = {
	"alertContainerClassName": "\"ba-alert-container\""
};